import { Magazine } from '../Datatypes';

export const useGetPreviewImage = () => {
    return async (magazine: Magazine): Promise<string> => {
        try {

            const articleImageData: any = await fetch(
                '/web-server-api/getImage',
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        "type": 'previewImage',
                        "date": magazine.date,
                        "edition": magazine.edition
                    }),
                }
            );

            const data = await articleImageData.json();
            const imageBase64 = data.base64ImageStr;

            if (imageBase64) {
                return `${imageBase64}`;
            }
            else {
                return ''; // Maybe show in this case some dummy image?
            }

        } catch (error) {
            console.error(`Error fetching preview image for ${magazine.date}-${magazine.edition}:`, error);
            return '';
        }
    };
};